import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { LoginPage } from './pages/LoginPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import VerificarPage from './pages/VerificarPage'
import { VerificarIntegradoPage } from './pages/VerificarIntegradoPage'
import { DashboardPage } from './pages/DashboardPage'
import { NotasVentaPage } from './pages/NotasVentaPage'
import { NuevaNotaPage } from './pages/NuevaNotaPage'
import { ClientesPage } from './pages/ClientesPage'
import { ProductosPage } from './pages/ProductosPage'
import { InventarioPage } from './pages/InventarioPage'
import UsuariosPage from './pages/UsuariosPage'
import AsignarInventarioPage from './pages/AsignarInventarioPage'
import MiInventarioPage from './pages/MiInventarioPage'
import ProveedoresPage from './pages/ProveedoresPage'
import { ConfiguracionPage } from './pages/ConfiguracionPage'
import { EstadisticasPage } from './pages/EstadisticasPage'
import { Layout } from './components/Layout'

// Componente para rutas protegidas
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const isHydrated = useAuthStore(state => state.isHydrated)
  
  // Esperar a que Zustand termine de rehidratar desde localStorage
  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }
  
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/v/:codigo" element={<VerificarPage />} />
        
        {/* Rutas protegidas */}
        <Route path="/" element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }>
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="notas-venta" element={<NotasVentaPage />} />
          <Route path="notas-venta/nueva" element={<NuevaNotaPage />} />
          <Route path="clientes" element={<ClientesPage />} />
          <Route path="productos" element={<ProductosPage />} />
          <Route path="inventario" element={<InventarioPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="asignar-inventario" element={<AsignarInventarioPage />} />
          <Route path="mi-inventario" element={<MiInventarioPage />} />
          <Route path="proveedores" element={<ProveedoresPage />} />
          <Route path="configuracion" element={<ConfiguracionPage />} />
          <Route path="estadisticas" element={<EstadisticasPage />} />
          <Route path="verificar" element={<VerificarIntegradoPage />} />
          <Route path="verificar/:codigo" element={<VerificarIntegradoPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
